module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00017.9a30e97c.jpg";